var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.manifest)?_c('ManifestPreview',{attrs:{"manifest":_vm.manifest,"fallback-accent":_vm.slide.accent}}):_c(_vm.resolved,{tag:"component",attrs:{"slide":_vm.slide}})
}
var staticRenderFns = []

export { render, staticRenderFns }